const PRACTICE_QUESTIONS = [

    /* ============= DOMAIN 1: Fundamentals of AI and ML (20%) — 18 questions ============= */
    {
        id: 1, domain: "D1",
        q: "A retail company wants to predict the price of a house based on features like square footage, number of bedrooms, and location. Which type of ML task is most appropriate?",
        options: [
            "Binary classification",
            "Multi-class classification",
            "Regression",
            "Clustering"
        ],
        correct: 2,
        explanation: "Regression is correct because the output is a continuous numerical value (price). Binary classification predicts one of two discrete categories. Multi-class classification predicts one of several discrete categories. Clustering groups data without predefined labels — it's unsupervised."
    },
    {
        id: 2, domain: "D1",
        q: "A data scientist notices that a model achieves 99% accuracy on training data but only 55% on test data. What is the most likely cause?",
        options: [
            "Underfitting due to insufficient model complexity",
            "Overfitting due to the model memorizing training data",
            "A poorly chosen loss function",
            "Insufficient training epochs"
        ],
        correct: 1,
        explanation: "Overfitting is correct — the large gap between training (99%) and test (55%) accuracy indicates the model memorized training data rather than learning generalizable patterns. Underfitting would show poor performance on BOTH sets. Loss function choice rarely causes this pattern. More epochs would likely worsen overfitting."
    },
    {
        id: 3, domain: "D1",
        q: "A company wants to group its customers into segments based on purchasing behavior without using any predefined categories. Which ML approach should they use?",
        options: [
            "Supervised learning with classification",
            "Unsupervised learning with clustering",
            "Reinforcement learning",
            "Supervised learning with regression"
        ],
        correct: 1,
        explanation: "Unsupervised clustering is correct because the goal is to discover natural groupings without predefined labels. Supervised classification requires labeled data. Reinforcement learning is for sequential decision-making with rewards. Regression predicts continuous values."
    },
    {
        id: 4, domain: "D1",
        q: "A machine learning model was trained to detect fraudulent transactions. Out of 100 flagged transactions, 80 were actually fraudulent. What metric does this 80% represent?",
        options: [
            "Recall",
            "Accuracy",
            "Precision",
            "F1 Score"
        ],
        correct: 2,
        explanation: "Precision is correct — it measures the proportion of predicted positives that are actually positive: TP/(TP+FP) = 80/100 = 80%. Recall measures the proportion of actual positives detected. Accuracy is overall correctness. F1 is the harmonic mean of precision and recall."
    },
    {
        id: 5, domain: "D1",
        q: "A team is building a model to detect rare diseases where missing a positive case has severe consequences. Which metric should they prioritize?",
        options: [
            "Precision",
            "Accuracy",
            "Recall",
            "Specificity"
        ],
        correct: 2,
        explanation: "Recall (sensitivity) is correct because missing a disease case (false negative) has severe consequences. High recall ensures most actual positive cases are detected, even if some predictions are false positives. Precision prioritizes avoiding false alarms. Accuracy can be misleading with rare classes. Specificity focuses on true negatives."
    },
    {
        id: 6, domain: "D1",
        q: "An ML engineer wants to reduce overfitting in a neural network. Which techniques would help? (Choose the most comprehensive answer)",
        options: [
            "Increase model complexity and add more layers",
            "Use regularization, dropout, and early stopping",
            "Remove all validation data and train longer",
            "Increase the learning rate significantly"
        ],
        correct: 1,
        explanation: "Regularization, dropout, and early stopping are all proven techniques to reduce overfitting. Increasing complexity makes overfitting worse. Removing validation data prevents you from detecting overfitting. A very high learning rate causes training instability."
    },
    {
        id: 7, domain: "D1",
        q: "A company has historical sales data and wants to predict future demand for the next 3 months. Which type of problem is this?",
        options: [
            "Classification problem",
            "Time series forecasting problem",
            "Clustering problem",
            "Anomaly detection problem"
        ],
        correct: 1,
        explanation: "Time series forecasting is correct — predicting future values based on historical temporal data. Classification assigns categories. Clustering finds groups. Anomaly detection identifies outliers. While forecasting uses regression techniques, the temporal nature makes it specifically a time series problem."
    },
    {
        id: 8, domain: "D1",
        q: "What is the primary difference between supervised and unsupervised learning?",
        options: [
            "Supervised learning uses GPUs; unsupervised learning uses CPUs",
            "Supervised learning uses labeled data; unsupervised learning finds patterns without labels",
            "Supervised learning is for text; unsupervised learning is for images",
            "Supervised learning is faster than unsupervised learning"
        ],
        correct: 1,
        explanation: "The defining difference is labeled vs unlabeled data. Supervised learning trains on input-output pairs to learn a mapping. Unsupervised learning discovers structure in data without known outputs. Both can use GPUs or CPUs, work with any data type, and speed depends on the specific algorithm."
    },
    {
        id: 9, domain: "D1",
        q: "A model is trained to recognize handwritten digits (0-9). What type of ML problem is this?",
        options: [
            "Regression",
            "Binary classification",
            "Multi-class classification",
            "Reinforcement learning"
        ],
        correct: 2,
        explanation: "Multi-class classification is correct — the model must assign each image to one of 10 discrete categories (digits 0-9). Binary classification handles only two classes. Regression predicts continuous values. Reinforcement learning involves agents interacting with environments."
    },
    {
        id: 10, domain: "D1",
        q: "A data scientist is evaluating a regression model and sees an RMSE of 15.2. How should they interpret this?",
        options: [
            "The model is 15.2% accurate",
            "On average, predictions deviate from actual values by approximately 15.2 units",
            "The model has 15.2 parameters",
            "The model processed 15.2 million data points"
        ],
        correct: 1,
        explanation: "RMSE (Root Mean Squared Error) represents the average magnitude of prediction errors in the same units as the target variable. An RMSE of 15.2 means predictions typically differ from actual values by about 15.2 units. It is not a percentage, not a parameter count, and not a data size metric."
    },
    {
        id: 11, domain: "D1",
        q: "Which technique allows a model trained on millions of general images to be adapted for a specific medical imaging task with limited data?",
        options: [
            "Data augmentation only",
            "Transfer learning",
            "Increasing the batch size",
            "Reducing the learning rate to zero"
        ],
        correct: 1,
        explanation: "Transfer learning is correct — it leverages knowledge from a pre-trained model (general images) and adapts it for a new domain (medical imaging) with limited data. Data augmentation helps but doesn't transfer existing knowledge. Batch size changes don't transfer knowledge. Zero learning rate means no learning."
    },
    {
        id: 12, domain: "D1",
        q: "During model training, an engineer notices the training loss decreasing but the validation loss starts increasing after epoch 50. What should they do?",
        options: [
            "Continue training for more epochs to improve performance",
            "Implement early stopping to stop training at around epoch 50",
            "Remove the validation set and retrain",
            "Increase the model size"
        ],
        correct: 1,
        explanation: "Early stopping is correct — the divergence between training and validation loss indicates overfitting starting at epoch 50. Continuing training worsens overfitting. Removing validation prevents detecting the problem. Increasing model size would likely make overfitting worse."
    },
    {
        id: 13, domain: "D1",
        q: "A company wants to detect manufacturing defects that occur in less than 0.1% of products. Which approach is best suited?",
        options: [
            "Standard binary classification with balanced data",
            "Anomaly detection or classification with techniques for imbalanced data",
            "Unsupervised clustering with K-means",
            "Simple rule-based threshold detection"
        ],
        correct: 1,
        explanation: "Anomaly detection or imbalanced classification techniques are correct because the defect rate (0.1%) creates a highly imbalanced dataset. Standard classification would overwhelmingly predict 'no defect.' K-means may not capture the subtle patterns. Simple rules miss complex defect patterns."
    },
    {
        id: 14, domain: "D1",
        q: "What is the role of a validation dataset in the ML workflow?",
        options: [
            "To train the model parameters directly",
            "To tune hyperparameters and make decisions during model development",
            "To serve as the final performance evaluation before deployment",
            "To store production inference results"
        ],
        correct: 1,
        explanation: "The validation set is used to tune hyperparameters and guide model development decisions without biasing the test evaluation. Training data fits model parameters. The test set provides the final unbiased evaluation. Production data is not used for model development."
    },
    {
        id: 15, domain: "D1",
        q: "An ML team uses k-fold cross-validation with k=5. What happens during this process?",
        options: [
            "The data is split once into 5 equal parts and 1 is used for testing",
            "The model is trained 5 times, each time using a different fold as validation and the rest for training",
            "5 different models are trained on 5 separate datasets",
            "The model trains for exactly 5 epochs"
        ],
        correct: 1,
        explanation: "In 5-fold cross-validation, data is split into 5 folds. The model trains 5 times — each time one fold serves as validation and the other 4 as training. Results are averaged for a more reliable performance estimate. It's not a single split, not separate datasets, and not related to epochs."
    },
    {
        id: 16, domain: "D1",
        q: "Which ensemble method combines multiple weak learners sequentially, where each new model corrects errors of the previous one?",
        options: [
            "Bagging",
            "Random Forest",
            "Boosting",
            "Stacking"
        ],
        correct: 2,
        explanation: "Boosting (e.g., XGBoost, AdaBoost) builds models sequentially, with each new model focusing on the errors of previous ones. Bagging trains models in parallel on random subsets. Random Forest is a specific bagging method. Stacking combines different model types with a meta-learner."
    },
    {
        id: 17, domain: "D1",
        q: "A feature in the training data has values ranging from 0 to 1,000,000. Another feature ranges from 0 to 1. What preprocessing step would help?",
        options: [
            "Deleting the larger feature",
            "Feature scaling or normalization",
            "Converting both features to categorical",
            "Duplicating the smaller feature"
        ],
        correct: 1,
        explanation: "Feature scaling/normalization brings features to a similar range, preventing the larger-valued feature from dominating the learning process. Deleting features loses information. Converting to categorical would lose numerical relationships. Duplicating doesn't address the scale mismatch."
    },
    {
        id: 18, domain: "D1",
        q: "What is the difference between batch inference and real-time inference?",
        options: [
            "Batch inference is always faster than real-time inference",
            "Real-time inference processes single requests immediately; batch processes large datasets at once on a schedule",
            "Batch inference is only for training; real-time is only for inference",
            "Real-time inference doesn't use ML models"
        ],
        correct: 1,
        explanation: "Real-time inference processes individual requests with low latency (e.g., each API call). Batch inference processes large collections of data at once, typically on a schedule (e.g., nightly). Batch is not necessarily faster per-item. Both are inference (not training). Both use ML models."
    },

    /* ============= DOMAIN 2: Fundamentals of Generative AI (24%) — 22 questions ============= */
    {
        id: 19, domain: "D2",
        q: "A developer wants to build an application that generates product descriptions using a pre-trained LLM. They want to reduce hallucinations by providing relevant product data. Which technique should they use?",
        options: [
            "Increase the model temperature to maximum",
            "Retrieval-Augmented Generation (RAG)",
            "Remove all context from the prompt",
            "Use a smaller model with fewer parameters"
        ],
        correct: 1,
        explanation: "RAG is correct — it retrieves relevant product data and includes it in the prompt, grounding the model's responses in factual information. Higher temperature increases randomness and hallucinations. Removing context gives the model nothing to ground on. Smaller models may hallucinate more."
    },
    {
        id: 20, domain: "D2",
        q: "What is the primary purpose of Amazon Bedrock?",
        options: [
            "To train custom neural networks from scratch",
            "To provide a managed service for accessing and using foundation models from multiple providers",
            "To create and manage relational databases",
            "To deploy containerized applications"
        ],
        correct: 1,
        explanation: "Amazon Bedrock provides managed access to foundation models from Anthropic, Meta, Cohere, Stability AI, and Amazon via a single API. It's not for training from scratch (that's SageMaker). It doesn't manage databases (that's RDS). It doesn't deploy containers (that's ECS/EKS)."
    },
    {
        id: 21, domain: "D2",
        q: "A company wants deterministic, consistent responses from their LLM-powered customer service bot. How should they configure the temperature parameter?",
        options: [
            "Set temperature to the maximum value (e.g., 2.0)",
            "Set temperature to a low value (e.g., 0.1 or 0)",
            "Set temperature to exactly 0.5",
            "Temperature has no effect on output consistency"
        ],
        correct: 1,
        explanation: "Low temperature (near 0) produces more deterministic, focused responses with less randomness — ideal for factual customer service. High temperature increases creativity and randomness. 0.5 is moderate. Temperature directly controls the randomness of token selection."
    },
    {
        id: 22, domain: "D2",
        q: "Which prompting technique provides a few examples of desired input-output pairs within the prompt itself?",
        options: [
            "Zero-shot prompting",
            "Chain-of-thought prompting",
            "Few-shot prompting",
            "System prompting"
        ],
        correct: 2,
        explanation: "Few-shot prompting includes examples directly in the prompt to guide the model's behavior. Zero-shot provides no examples. Chain-of-thought asks the model to reason step by step. System prompting sets overall behavior context, not task examples."
    },
    {
        id: 23, domain: "D2",
        q: "A developer is building a RAG system for a legal firm. What components are needed?",
        options: [
            "Only a large language model with maximum context window",
            "A document store, embedding model, vector database, and a language model for generation",
            "Only a database and a web server",
            "Only a search engine like Elasticsearch"
        ],
        correct: 1,
        explanation: "A RAG system requires: a document store (source documents), embedding model (converts text to vectors), vector database (stores and searches embeddings), and an LLM for generation. Just an LLM alone can hallucinate. A database alone can't generate text. A search engine alone doesn't generate responses."
    },
    {
        id: 24, domain: "D2",
        q: "What is Amazon Bedrock's Knowledge Base feature used for?",
        options: [
            "Training custom foundation models from scratch",
            "Building managed RAG systems by connecting foundation models to enterprise data sources",
            "Creating relational database schemas",
            "Monitoring application performance"
        ],
        correct: 1,
        explanation: "Knowledge Bases for Amazon Bedrock provides managed RAG — it automatically handles document ingestion, chunking, embedding, vector storage, and retrieval to ground model responses in your data. It doesn't train models from scratch, manage databases, or monitor performance."
    },
    {
        id: 25, domain: "D2",
        q: "What is the concept of 'hallucination' in the context of large language models?",
        options: [
            "The model takes too long to generate a response",
            "The model generates plausible but factually incorrect or fabricated information",
            "The model refuses to answer a question",
            "The model produces garbled, unreadable text"
        ],
        correct: 1,
        explanation: "Hallucination occurs when LLMs produce confident-sounding but incorrect or fabricated information. This is a fundamental challenge because the output appears believable. Slow responses are latency issues. Refusals are safety behaviors. Garbled text is a different failure mode."
    },
    {
        id: 26, domain: "D2",
        q: "Which AWS service allows business analysts to build generative AI applications without coding?",
        options: [
            "Amazon SageMaker",
            "PartyRock (Amazon Bedrock Playground)",
            "AWS Lambda",
            "Amazon EMR"
        ],
        correct: 1,
        explanation: "PartyRock is Amazon's no-code Bedrock playground for building and sharing gen AI apps without programming. SageMaker requires technical ML skills. Lambda requires coding. EMR is for big data processing."
    },
    {
        id: 27, domain: "D2",
        q: "A team wants to customize a foundation model for their specific medical terminology. The model should learn new domain knowledge while keeping general capabilities. What approach is best?",
        options: [
            "Use prompt engineering only",
            "Fine-tune the model with domain-specific medical data",
            "Build a completely new model from scratch",
            "Use a higher temperature setting"
        ],
        correct: 1,
        explanation: "Fine-tuning updates the model's weights with domain-specific data, teaching it new medical terminology while preserving general knowledge. Prompt engineering alone can't teach new terminology. Building from scratch is impractical and wasteful. Temperature doesn't add knowledge."
    },
    {
        id: 28, domain: "D2",
        q: "What is the purpose of embeddings in the context of generative AI?",
        options: [
            "To compress images for faster loading",
            "To represent text, images, or other data as numerical vectors where similar items are closer together in vector space",
            "To encrypt sensitive data",
            "To store data in relational databases"
        ],
        correct: 1,
        explanation: "Embeddings convert data into dense numerical vectors where semantic similarity is captured by proximity in vector space. This enables semantic search, RAG, and recommendations. They're not for image compression, encryption, or relational storage."
    },
    {
        id: 29, domain: "D2",
        q: "Which architecture underpins most modern large language models like GPT, Claude, and Llama?",
        options: [
            "Convolutional Neural Network (CNN)",
            "Recurrent Neural Network (RNN)",
            "Transformer architecture",
            "Decision tree ensemble"
        ],
        correct: 2,
        explanation: "The Transformer architecture (introduced in 'Attention Is All You Need') is the foundation of modern LLMs. It uses self-attention mechanisms for parallel processing. CNNs are primarily for images. RNNs process sequentially and struggle with long sequences. Decision trees are traditional ML."
    },
    {
        id: 30, domain: "D2",
        q: "What is the 'context window' of a large language model?",
        options: [
            "The physical screen size used to view the model's output",
            "The maximum number of tokens the model can process in a single prompt and response combined",
            "The time period during which the model remembers conversations",
            "The number of users who can access the model simultaneously"
        ],
        correct: 1,
        explanation: "The context window is the maximum token capacity for input + output in a single interaction. Larger windows allow processing longer documents but cost more. It's not about display size, conversation memory across sessions, or concurrent user limits."
    },
    {
        id: 31, domain: "D2",
        q: "A developer is comparing foundation models on Amazon Bedrock for a text generation task. Which factors should they consider?",
        options: [
            "Only the model's parameter count",
            "Task quality, latency, cost per token, context window size, and supported languages",
            "Only the model provider's brand recognition",
            "Only the most expensive option for best quality"
        ],
        correct: 1,
        explanation: "Model selection requires evaluating multiple factors: quality for the specific task, latency requirements, cost per token, context window needs, and language support. Parameter count alone doesn't determine suitability. Brand and price aren't sole indicators of fitness for purpose."
    },
    {
        id: 32, domain: "D2",
        q: "What does RLHF (Reinforcement Learning from Human Feedback) accomplish in LLM development?",
        options: [
            "It increases the model's parameter count",
            "It aligns the model's behavior with human preferences and values",
            "It compresses the model for faster inference",
            "It converts the model from text to image generation"
        ],
        correct: 1,
        explanation: "RLHF trains the model to produce outputs that humans prefer, making it more helpful, harmless, and honest. It doesn't change parameter count, compress models, or change modality. It uses human preference data to create a reward model that guides the LLM's behavior."
    },
    {
        id: 33, domain: "D2",
        q: "What is the primary benefit of using Agents for Amazon Bedrock?",
        options: [
            "They reduce the cost of model inference to zero",
            "They enable foundation models to execute multi-step tasks by orchestrating API calls and knowledge base queries",
            "They automatically train new foundation models",
            "They replace the need for any programming"
        ],
        correct: 1,
        explanation: "Bedrock Agents enable FMs to break down tasks, call APIs, access knowledge bases, and execute multi-step workflows autonomously. They don't eliminate costs, train new models, or remove all programming needs."
    },
    {
        id: 34, domain: "D2",
        q: "Which type of generative AI model creates images by gradually removing noise from random data?",
        options: [
            "Generative Adversarial Network (GAN)",
            "Variational Autoencoder (VAE)",
            "Diffusion model",
            "Recurrent Neural Network"
        ],
        correct: 2,
        explanation: "Diffusion models (like Stable Diffusion, DALL-E 3) learn to denoise — they start from random noise and gradually remove it to form coherent images. GANs use adversarial generator-discriminator pairs. VAEs use encoder-decoder with latent distributions. RNNs process sequences."
    },
    {
        id: 35, domain: "D2",
        q: "A user asks a foundation model: 'Summarize this 500-page legal document.' The model returns an error about exceeding limits. What is the most likely issue?",
        options: [
            "The model has a bug",
            "The document exceeds the model's context window",
            "The model cannot process text at all",
            "The user lacks IAM permissions"
        ],
        correct: 1,
        explanation: "The document likely exceeds the model's context window — the maximum tokens it can process. 500 pages would be hundreds of thousands of tokens, exceeding most models' limits. Solutions include chunking the document or using a model with a larger context window."
    },
    {
        id: 36, domain: "D2",
        q: "What is the difference between pre-training and fine-tuning a foundation model?",
        options: [
            "Pre-training is faster and cheaper than fine-tuning",
            "Pre-training learns general knowledge from massive datasets; fine-tuning adapts the model to specific tasks or domains with smaller datasets",
            "Fine-tuning always requires more data than pre-training",
            "They are the same process with different names"
        ],
        correct: 1,
        explanation: "Pre-training is the initial, expensive phase using massive general datasets to learn broad patterns. Fine-tuning is the subsequent, cheaper phase using smaller domain-specific data to adapt the model. Pre-training is much more expensive. Fine-tuning uses less data. They are distinct phases."
    },
    {
        id: 37, domain: "D2",
        q: "Which Amazon service provides pre-built foundation models for text embeddings?",
        options: [
            "Amazon Polly",
            "Amazon Titan Embeddings via Amazon Bedrock",
            "Amazon DynamoDB",
            "Amazon CloudFront"
        ],
        correct: 1,
        explanation: "Amazon Titan Embeddings, available through Bedrock, converts text into vector embeddings for semantic search and RAG applications. Polly is text-to-speech. DynamoDB is a NoSQL database. CloudFront is a CDN."
    },
    {
        id: 38, domain: "D2",
        q: "A developer uses chain-of-thought prompting for a math problem. What does this technique do?",
        options: [
            "Makes the model generate shorter responses",
            "Instructs the model to reason through intermediate steps before giving a final answer",
            "Automatically fine-tunes the model",
            "Encrypts the prompt for security"
        ],
        correct: 1,
        explanation: "Chain-of-thought prompting asks the model to show its reasoning process step by step, improving accuracy on complex problems like math, logic, and multi-step tasks. It doesn't shorten responses, fine-tune, or encrypt."
    },
    {
        id: 39, domain: "D2",
        q: "What distinguishes a multimodal AI model from a text-only LLM?",
        options: [
            "Multimodal models are always larger",
            "Multimodal models can process and generate multiple data types like text, images, and audio",
            "Multimodal models can only handle images",
            "Multimodal models run only on specialized hardware"
        ],
        correct: 1,
        explanation: "Multimodal models handle multiple data types — they can understand images + text together, generate from different modalities, etc. They aren't necessarily larger, aren't limited to images, and can run on standard cloud hardware."
    },
    {
        id: 40, domain: "D2",
        q: "Which Bedrock feature allows you to log all model invocations including prompts and completions for auditing purposes?",
        options: [
            "Guardrails for Amazon Bedrock",
            "Model invocation logging",
            "Amazon Bedrock Agents",
            "Amazon Bedrock Knowledge Bases"
        ],
        correct: 1,
        explanation: "Model invocation logging in Bedrock records all API calls including full prompts and model responses. Logs go to S3 and CloudWatch for auditing and compliance. Guardrails filter content. Agents execute tasks. Knowledge Bases handle RAG."
    },

    /* ============= DOMAIN 3: Applications of Foundation Models (28%) — 25 questions ============= */
    {
        id: 41, domain: "D3",
        q: "A healthcare company needs to extract patient information from handwritten medical forms. Which AWS service is best suited?",
        options: [
            "Amazon Comprehend",
            "Amazon Textract",
            "Amazon Translate",
            "Amazon Polly"
        ],
        correct: 1,
        explanation: "Amazon Textract extracts text, forms, and tables from scanned documents and images, including handwritten text. Comprehend analyzes text content but doesn't extract from images. Translate converts between languages. Polly converts text to speech."
    },
    {
        id: 42, domain: "D3",
        q: "An e-commerce company wants to build a recommendation engine similar to Amazon.com's 'Customers who bought this also bought...' feature. Which AWS service should they use?",
        options: [
            "Amazon Kendra",
            "Amazon Personalize",
            "Amazon Comprehend",
            "Amazon Forecast"
        ],
        correct: 1,
        explanation: "Amazon Personalize is a managed recommendation service using the same technology as Amazon.com. It provides real-time personalized recommendations. Kendra is for enterprise search. Comprehend is for NLP. Forecast is for time series prediction."
    },
    {
        id: 43, domain: "D3",
        q: "A company needs to add real-time speech-to-text capability to their call center application. Which AWS service should they use?",
        options: [
            "Amazon Polly",
            "Amazon Transcribe",
            "Amazon Translate",
            "Amazon Lex"
        ],
        correct: 1,
        explanation: "Amazon Transcribe provides automatic speech recognition (ASR) for converting speech to text in real-time. Polly does the reverse (text to speech). Translate converts between languages. Lex builds conversational interfaces but uses Transcribe under the hood."
    },
    {
        id: 44, domain: "D3",
        q: "A media company wants to automatically detect inappropriate content in user-uploaded images. Which AWS service should they use?",
        options: [
            "Amazon Comprehend",
            "Amazon Rekognition Content Moderation",
            "Amazon Textract",
            "Amazon Translate"
        ],
        correct: 1,
        explanation: "Amazon Rekognition provides content moderation that detects inappropriate, unwanted, or offensive images and videos. Comprehend analyzes text. Textract extracts text from documents. Translate handles language conversion."
    },
    {
        id: 45, domain: "D3",
        q: "A company wants to build a chatbot that handles customer inquiries via both text and voice. Which AWS service is specifically designed for this?",
        options: [
            "Amazon Comprehend",
            "Amazon Lex",
            "Amazon Transcribe",
            "Amazon Polly"
        ],
        correct: 1,
        explanation: "Amazon Lex is specifically designed for building conversational interfaces (chatbots) with both speech and text capabilities. It includes ASR and NLU built-in. Comprehend does NLP analysis. Transcribe is speech-to-text only. Polly is text-to-speech only."
    },
    {
        id: 46, domain: "D3",
        q: "A business analyst with no coding experience wants to build an ML model to predict customer churn from a CSV file. Which tool is best?",
        options: [
            "Amazon SageMaker Studio notebooks",
            "Amazon SageMaker Canvas",
            "AWS Lambda",
            "Amazon EMR"
        ],
        correct: 1,
        explanation: "SageMaker Canvas is a no-code ML tool with a visual interface designed for business users. It can build models from CSV data without coding. SageMaker Studio requires coding skills. Lambda is for serverless functions. EMR is for big data processing."
    },
    {
        id: 47, domain: "D3",
        q: "A company needs to translate their product catalog into 15 languages. Which AWS service provides neural machine translation?",
        options: [
            "Amazon Comprehend",
            "Amazon Translate",
            "Amazon Transcribe",
            "Amazon Polly"
        ],
        correct: 1,
        explanation: "Amazon Translate provides neural machine translation supporting 75+ languages with custom terminology support. Comprehend analyzes text (NLP). Transcribe converts speech to text. Polly converts text to speech."
    },
    {
        id: 48, domain: "D3",
        q: "An ML team needs to create high-quality labeled training data for an image classification project. They have a limited budget. Which AWS service helps?",
        options: [
            "Amazon Rekognition",
            "SageMaker Ground Truth",
            "Amazon Comprehend",
            "SageMaker Canvas"
        ],
        correct: 1,
        explanation: "SageMaker Ground Truth is a managed data labeling service that combines human labelers with active learning to create labeled datasets cost-effectively. Rekognition performs image analysis but doesn't label training data. Comprehend is for NLP. Canvas is for no-code ML."
    },
    {
        id: 49, domain: "D3",
        q: "A deployed model's accuracy has been decreasing over the past month. Which tool monitors for this type of model quality degradation?",
        options: [
            "Amazon CloudWatch",
            "SageMaker Model Monitor",
            "AWS Config",
            "Amazon Inspector"
        ],
        correct: 1,
        explanation: "SageMaker Model Monitor specifically detects data drift and model quality degradation in deployed models. CloudWatch monitors infrastructure metrics but not model-specific quality. Config tracks resource configurations. Inspector is for security vulnerabilities."
    },
    {
        id: 50, domain: "D3",
        q: "A company wants to search their internal wiki using natural language questions. Which AWS service provides ML-powered enterprise search?",
        options: [
            "Amazon OpenSearch Service",
            "Amazon Kendra",
            "Amazon Comprehend",
            "Amazon Textract"
        ],
        correct: 1,
        explanation: "Amazon Kendra is an enterprise search service powered by ML that understands natural language questions and returns precise answers from documents. OpenSearch provides traditional keyword search. Comprehend analyzes text. Textract extracts text from documents."
    },
    {
        id: 51, domain: "D3",
        q: "A retail company wants to forecast product demand for the next quarter. Which AWS service specializes in time series forecasting?",
        options: [
            "Amazon Personalize",
            "Amazon Forecast",
            "Amazon Comprehend",
            "Amazon Rekognition"
        ],
        correct: 1,
        explanation: "Amazon Forecast uses ML for time series forecasting — predicting future values like product demand. Personalize is for recommendations. Comprehend is for NLP. Rekognition is for image/video analysis."
    },
    {
        id: 52, domain: "D3",
        q: "A developer needs to quickly deploy a pre-trained foundation model for text generation without managing infrastructure. Which SageMaker feature provides one-click deployment?",
        options: [
            "SageMaker Canvas",
            "SageMaker JumpStart",
            "SageMaker Ground Truth",
            "SageMaker Feature Store"
        ],
        correct: 1,
        explanation: "SageMaker JumpStart provides a hub of pre-trained models with one-click deployment capabilities. Canvas is no-code ML for business users. Ground Truth is for data labeling. Feature Store manages ML features."
    },
    {
        id: 53, domain: "D3",
        q: "A team wants to automate their ML workflow from data preparation through model training to deployment. Which SageMaker feature enables this?",
        options: [
            "SageMaker Canvas",
            "SageMaker Pipelines",
            "SageMaker Ground Truth",
            "SageMaker Clarify"
        ],
        correct: 1,
        explanation: "SageMaker Pipelines provides CI/CD for ML — building, automating, and managing end-to-end ML workflows. Canvas is for no-code ML. Ground Truth is for data labeling. Clarify is for bias detection and explainability."
    },
    {
        id: 54, domain: "D3",
        q: "A company wants to analyze customer support emails to determine whether each email is positive, negative, or neutral. Which AWS service is best?",
        options: [
            "Amazon Lex",
            "Amazon Comprehend",
            "Amazon Transcribe",
            "Amazon Translate"
        ],
        correct: 1,
        explanation: "Amazon Comprehend provides sentiment analysis that classifies text as positive, negative, neutral, or mixed. Lex builds chatbots. Transcribe converts speech to text. Translate handles language translation."
    },
    {
        id: 55, domain: "D3",
        q: "A developer wants to use Amazon Bedrock to build an application where the AI can search a company's documents before answering questions. Which Bedrock feature should they use?",
        options: [
            "Guardrails for Amazon Bedrock",
            "Knowledge Bases for Amazon Bedrock",
            "Model invocation logging",
            "Amazon Bedrock custom model training"
        ],
        correct: 1,
        explanation: "Knowledge Bases for Amazon Bedrock provides managed RAG — connecting foundation models to your document repositories so they can retrieve relevant information before generating answers. Guardrails filter content. Logging records invocations. Custom training fine-tunes models."
    },
    {
        id: 56, domain: "D3",
        q: "Which approach to customizing a foundation model requires the LEAST computational resources and does NOT change model weights?",
        options: [
            "Continued pre-training",
            "Fine-tuning with LoRA",
            "Prompt engineering",
            "Full fine-tuning"
        ],
        correct: 2,
        explanation: "Prompt engineering customizes model behavior through carefully designed inputs without any training or weight changes. It requires no compute for training. Continued pre-training and full fine-tuning are most expensive. LoRA fine-tuning requires moderate compute."
    },
    {
        id: 57, domain: "D3",
        q: "A company needs their AI application to recognize company-specific product names in customer emails. Which combination of AWS services would work best?",
        options: [
            "Amazon Translate + Amazon Polly",
            "Amazon Comprehend with custom entities",
            "Amazon Rekognition + Amazon Textract",
            "Amazon Lex + Amazon Forecast"
        ],
        correct: 1,
        explanation: "Amazon Comprehend custom entities allows you to train the service to recognize domain-specific entities like product names. Translate + Polly handle translation and speech. Rekognition + Textract handle images. Lex + Forecast handle chatbots and time series."
    },
    {
        id: 58, domain: "D3",
        q: "A SageMaker model was deployed 6 months ago. The data science team notices that input data distributions have changed significantly. What is this phenomenon called?",
        options: [
            "Model overfitting",
            "Data drift",
            "Feature engineering",
            "Hyperparameter tuning"
        ],
        correct: 1,
        explanation: "Data drift occurs when the statistical properties of input data change over time compared to training data. This can degrade model performance. Overfitting is a training issue. Feature engineering creates input variables. Hyperparameter tuning optimizes training settings."
    },
    {
        id: 59, domain: "D3",
        q: "A developer wants to create a text-to-image generation application using AWS services. Which option is available through Amazon Bedrock?",
        options: [
            "Amazon Rekognition Image Generator",
            "Amazon Titan Image Generator or Stability AI models",
            "Amazon Polly Visual",
            "Amazon Comprehend Image Creator"
        ],
        correct: 1,
        explanation: "Amazon Bedrock provides access to Amazon Titan Image Generator and Stability AI (Stable Diffusion) models for text-to-image generation. Rekognition analyzes images but doesn't generate them. The other options don't exist."
    },
    {
        id: 60, domain: "D3",
        q: "A company wants to centrally store and share ML features between different teams and models. Which SageMaker capability should they use?",
        options: [
            "SageMaker Feature Store",
            "SageMaker Ground Truth",
            "SageMaker Canvas",
            "SageMaker Clarify"
        ],
        correct: 0,
        explanation: "SageMaker Feature Store is a centralized repository for storing, sharing, and managing ML features with both online (real-time) and offline (batch) access. Ground Truth handles labeling. Canvas is no-code ML. Clarify detects bias."
    },
    {
        id: 61, domain: "D3",
        q: "A customer service application uses Amazon Lex for a chatbot. The bot needs to look up order status from a database. How is this typically implemented?",
        options: [
            "Lex directly queries the database",
            "Lex triggers an AWS Lambda function that queries the database and returns the result",
            "Lex sends an email to a human agent",
            "Lex uses Amazon Forecast to predict the answer"
        ],
        correct: 1,
        explanation: "Amazon Lex integrates with AWS Lambda for fulfillment — when Lex identifies an intent, it triggers a Lambda function that executes business logic like database queries. Lex doesn't directly query databases. Emails defeat the purpose. Forecast is for time series."
    },
    {
        id: 62, domain: "D3",
        q: "An ML engineer needs to detect PII (names, SSNs, addresses) in a large text dataset before using it for training. Which AWS service can help?",
        options: [
            "Amazon Macie",
            "Amazon Comprehend PII detection",
            "Amazon Rekognition",
            "Amazon Polly"
        ],
        correct: 1,
        explanation: "Amazon Comprehend provides PII detection and redaction for text data. It identifies entities like names, addresses, SSNs, and more. Macie detects sensitive data in S3 (files, not text analysis). Rekognition handles images. Polly handles speech."
    },
    {
        id: 63, domain: "D3",
        q: "A startup wants to deploy a foundation model but can't decide between prompt engineering and fine-tuning. When is fine-tuning preferred over prompt engineering?",
        options: [
            "Always — fine-tuning is always better",
            "When the model needs to learn domain-specific terminology, formats, or behaviors that prompts alone can't achieve",
            "When cost is the primary concern",
            "When the team has no data"
        ],
        correct: 1,
        explanation: "Fine-tuning is preferred when prompts can't achieve the needed specialization — like learning new terminology, specific output formats, or domain behaviors. It's not always better (sometimes prompts suffice). It costs more than prompting. It requires domain-specific data."
    },
    {
        id: 64, domain: "D3",
        q: "A company wants to use Amazon Q Developer to assist their software engineers. What can Amazon Q Developer help with?",
        options: [
            "Generating code, explaining code, debugging, and providing AWS recommendations",
            "Only translating code between programming languages",
            "Only managing AWS infrastructure",
            "Only creating documentation"
        ],
        correct: 0,
        explanation: "Amazon Q Developer provides comprehensive coding assistance: code generation, code explanation, debugging help, security scanning, and AWS-specific recommendations. It does much more than just translation, infrastructure management, or documentation."
    },
    {
        id: 65, domain: "D3",
        q: "A developer is choosing between Amazon Bedrock and Amazon SageMaker for their gen AI project. When is SageMaker the better choice?",
        options: [
            "When they need quick access to managed foundation models via API",
            "When they need to train custom models, have full control over infrastructure, or need advanced MLOps capabilities",
            "When they want a no-code solution",
            "When they only need text generation"
        ],
        correct: 1,
        explanation: "SageMaker is better when you need custom model training, fine-grained infrastructure control, or comprehensive MLOps pipelines. Bedrock is better for quick API-based access to managed FMs. No-code would be SageMaker Canvas or PartyRock. Both handle text generation."
    },

    /* ============= DOMAIN 4: Guidelines for Responsible AI (14%) — 13 questions ============= */
    {
        id: 66, domain: "D4",
        q: "A hiring AI model consistently ranks candidates from certain universities higher regardless of qualifications. What type of bias does this represent?",
        options: [
            "Measurement bias",
            "Historical bias in training data",
            "Sampling bias",
            "Confirmation bias"
        ],
        correct: 1,
        explanation: "Historical bias occurs when training data reflects existing societal prejudices — if past hiring data favored certain universities, the model learns and perpetuates this. Measurement bias involves proxy variables. Sampling bias is about non-representative data. Confirmation bias reinforces existing beliefs."
    },
    {
        id: 67, domain: "D4",
        q: "A bank uses an AI model for loan decisions. Regulators require the bank to explain why individual applications were denied. Which AWS tool provides this capability?",
        options: [
            "Amazon CloudWatch",
            "SageMaker Clarify",
            "AWS Config",
            "Amazon Inspector"
        ],
        correct: 1,
        explanation: "SageMaker Clarify provides model explainability through feature importance scores (SHAP values) that explain individual predictions. CloudWatch monitors metrics. Config tracks resource configurations. Inspector is for security vulnerabilities."
    },
    {
        id: 68, domain: "D4",
        q: "A company wants to prevent their customer-facing chatbot from discussing politics, religion, or competitor products. Which Bedrock feature helps enforce this?",
        options: [
            "Amazon Bedrock Knowledge Bases",
            "Guardrails for Amazon Bedrock",
            "Amazon Bedrock Agents",
            "Model invocation logging"
        ],
        correct: 1,
        explanation: "Guardrails for Amazon Bedrock allows configuring denied topics, content filters, and word filters to control what the model can discuss. Knowledge Bases connect to data sources. Agents execute tasks. Logging records interactions."
    },
    {
        id: 69, domain: "D4",
        q: "An AI-generated image service includes invisible watermarks in every output. What responsible AI principle does this serve?",
        options: [
            "Performance optimization",
            "Transparency and accountability — enabling tracking of AI-generated content",
            "Cost reduction",
            "Model accuracy improvement"
        ],
        correct: 1,
        explanation: "Watermarking serves transparency and accountability by enabling identification and tracking of AI-generated content. Amazon Titan Image Generator includes invisible watermarks. It doesn't optimize performance, reduce costs, or improve accuracy."
    },
    {
        id: 70, domain: "D4",
        q: "A company discovers their facial recognition model performs significantly worse for certain demographic groups. This is an example of:",
        options: [
            "Overfitting",
            "Disparate impact / fairness issue",
            "Underfitting",
            "Feature drift"
        ],
        correct: 1,
        explanation: "Disparate impact occurs when an AI system produces significantly different performance across demographic groups. This is a fundamental fairness issue requiring bias investigation and mitigation. Overfitting/underfitting are training issues. Feature drift is about changing data."
    },
    {
        id: 71, domain: "D4",
        q: "A medical AI system is deployed for initial diagnosis screening. What responsible AI design pattern is MOST important for this high-stakes application?",
        options: [
            "Fully automated decision-making for speed",
            "Human-in-the-loop with physician review of AI recommendations",
            "Removing all human oversight to reduce errors",
            "Using the largest possible model"
        ],
        correct: 1,
        explanation: "Human-in-the-loop is critical for high-stakes medical decisions — AI should assist physicians, not replace them. Medical AI recommendations should be reviewed by qualified humans. Fully automated or no-oversight approaches risk patient safety. Model size alone doesn't ensure safety."
    },
    {
        id: 72, domain: "D4",
        q: "Which of the following is a pre-processing technique for mitigating bias in training data?",
        options: [
            "Adjusting model predictions after inference",
            "Resampling, reweighting, or augmenting underrepresented groups in the training data",
            "Increasing model complexity",
            "Using a higher temperature during inference"
        ],
        correct: 1,
        explanation: "Pre-processing bias mitigation works on the data before training — balancing representation through resampling, reweighting, or augmenting underrepresented groups. Post-processing adjusts predictions after inference. Model complexity and temperature don't address data bias."
    },
    {
        id: 73, domain: "D4",
        q: "What is a 'model card' in the context of responsible AI?",
        options: [
            "A credit card used to pay for AI services",
            "Structured documentation describing a model's purpose, performance, limitations, and ethical considerations",
            "A hardware component in AI servers",
            "A dashboard showing real-time model metrics"
        ],
        correct: 1,
        explanation: "Model cards are standardized documentation that transparently communicate what a model does, how it performs, its limitations, and ethical considerations. They promote responsible deployment and informed usage decisions."
    },
    {
        id: 74, domain: "D4",
        q: "A company's AI customer service bot occasionally generates offensive responses. What Bedrock feature provides the FIRST line of defense?",
        options: [
            "Model invocation logging",
            "Guardrails with content filters for toxicity, violence, and hate speech",
            "Knowledge Bases",
            "Custom model training"
        ],
        correct: 1,
        explanation: "Guardrails content filters are the first line of defense — they evaluate and block harmful outputs before they reach users. Logging records but doesn't prevent issues. Knowledge Bases help with accuracy not safety. Custom training may help but is slower to implement."
    },
    {
        id: 75, domain: "D4",
        q: "An AI system used for credit scoring creates a feedback loop where denied applicants never get a chance to build credit, further reinforcing the model's denial pattern. What is this called?",
        options: [
            "Data drift",
            "A negative feedback loop / automation bias",
            "Model convergence",
            "Feature importance"
        ],
        correct: 1,
        explanation: "This is a negative feedback loop where model decisions influence future training data, amplifying existing biases. Denied applicants can't build credit, producing more denial data, reinforcing the pattern. Data drift is different. Convergence is about training. Feature importance explains predictions."
    },
    {
        id: 76, domain: "D4",
        q: "According to responsible AI principles, when should a company inform users they are interacting with an AI system?",
        options: [
            "Only when legally required",
            "Always — users should know when they're interacting with AI vs. a human",
            "Never — it would reduce trust",
            "Only if the AI makes a mistake"
        ],
        correct: 1,
        explanation: "Transparency requires always disclosing AI involvement. Users have the right to know when they're interacting with AI. This builds trust rather than undermining it. Waiting for legal requirements or mistakes is insufficient for responsible AI."
    },
    {
        id: 77, domain: "D4",
        q: "Red teaming in the context of AI safety involves:",
        options: [
            "Choosing a red color theme for the AI interface",
            "Dedicated teams that deliberately try to find vulnerabilities, biases, and failure modes in AI systems before deployment",
            "Training the model on red-colored images",
            "Reducing the model's temperature to zero"
        ],
        correct: 1,
        explanation: "AI red teaming means dedicated adversarial testing — teams try to make the AI fail, produce harmful outputs, or exhibit biases before deployment. It's borrowed from cybersecurity practices and is essential for responsible AI deployment."
    },
    {
        id: 78, domain: "D4",
        q: "Which AWS service specifically helps detect bias in both training data AND model predictions?",
        options: [
            "Amazon CloudWatch",
            "SageMaker Clarify",
            "AWS Trusted Advisor",
            "Amazon Detective"
        ],
        correct: 1,
        explanation: "SageMaker Clarify detects bias at multiple stages: in training data (pre-training bias metrics) and in model predictions (post-training bias metrics), plus provides explainability. CloudWatch monitors infrastructure. Trusted Advisor gives AWS best practices. Detective investigates security findings."
    },

    /* ============= DOMAIN 5: Security, Compliance, and Governance (14%) — 12 questions ============= */
    {
        id: 79, domain: "D5",
        q: "Under the AWS Shared Responsibility Model for Amazon Bedrock, what is the CUSTOMER responsible for?",
        options: [
            "Maintaining the physical security of AWS data centers",
            "Securing their data, prompts, IAM policies, and application-level controls",
            "Patching the underlying foundation model infrastructure",
            "Managing the Bedrock API gateway"
        ],
        correct: 1,
        explanation: "Customers are responsible for their data (prompts, responses, training data), IAM access controls, application security, and compliance. AWS handles physical infrastructure, model hosting, and service-level security."
    },
    {
        id: 80, domain: "D5",
        q: "A company needs to ensure that all API calls to Amazon Bedrock are recorded for compliance auditing. Which AWS service provides this?",
        options: [
            "Amazon CloudWatch Logs",
            "AWS CloudTrail",
            "Amazon Macie",
            "AWS Trusted Advisor"
        ],
        correct: 1,
        explanation: "AWS CloudTrail records API calls to AWS services including Bedrock, providing an audit trail of who did what and when. CloudWatch Logs captures application logs. Macie discovers sensitive data. Trusted Advisor provides cost/security recommendations."
    },
    {
        id: 81, domain: "D5",
        q: "A financial services company needs to access Amazon Bedrock without sending traffic over the public internet. What should they use?",
        options: [
            "A NAT gateway",
            "AWS PrivateLink / VPC endpoints",
            "Amazon CloudFront",
            "An internet gateway"
        ],
        correct: 1,
        explanation: "AWS PrivateLink (VPC endpoints) enables private connectivity to Bedrock entirely within the AWS network, avoiding the public internet. NAT gateways route to the internet. CloudFront is a CDN. Internet gateways enable public internet access."
    },
    {
        id: 82, domain: "D5",
        q: "An attacker crafts a prompt that tricks an AI chatbot into revealing its system instructions and customer data. What type of attack is this?",
        options: [
            "SQL injection",
            "Prompt injection",
            "DDoS attack",
            "Man-in-the-middle attack"
        ],
        correct: 1,
        explanation: "Prompt injection is a security attack specific to AI systems where malicious input manipulates the model into ignoring instructions or revealing sensitive information. SQL injection targets databases. DDoS overwhelms services. MITM intercepts network traffic."
    },
    {
        id: 83, domain: "D5",
        q: "A company uses Amazon SageMaker to train models on sensitive healthcare data. How should they encrypt the training data at rest?",
        options: [
            "Encryption is not possible for SageMaker data",
            "Use AWS KMS to encrypt S3 buckets storing training data and SageMaker training volumes",
            "Use HTTP instead of HTTPS",
            "Store data in plain text for faster processing"
        ],
        correct: 1,
        explanation: "AWS KMS provides encryption key management for encrypting training data in S3 (SSE-KMS) and SageMaker EBS volumes. Encryption is absolutely possible and recommended. HTTP is not encryption. Plain text storage violates healthcare security requirements."
    },
    {
        id: 84, domain: "D5",
        q: "A company's AI governance team wants to track all versions of deployed models with approval workflows. Which SageMaker feature provides this?",
        options: [
            "SageMaker Canvas",
            "SageMaker Model Registry",
            "SageMaker Ground Truth",
            "SageMaker Autopilot"
        ],
        correct: 1,
        explanation: "SageMaker Model Registry provides centralized model version management with metadata, approval status tracking, and deployment history for governance. Canvas is no-code ML. Ground Truth is labeling. Autopilot automates model building."
    },
    {
        id: 85, domain: "D5",
        q: "An organization needs to restrict certain AWS accounts from using specific AI services. Which AWS mechanism enforces this?",
        options: [
            "IAM user policies only",
            "Service Control Policies (SCPs) in AWS Organizations",
            "Amazon CloudWatch Alarms",
            "Security group rules"
        ],
        correct: 1,
        explanation: "SCPs in AWS Organizations set permission guardrails across accounts, preventing access to specified services regardless of individual IAM permissions. IAM policies apply to individual accounts. CloudWatch monitors metrics. Security groups control network access."
    },
    {
        id: 86, domain: "D5",
        q: "A company must comply with GDPR for their AI application that processes EU citizen data. Which requirement is MOST relevant to automated decision-making?",
        options: [
            "All data must be stored in the EU only",
            "Individuals have the right to meaningful information about the logic of automated decisions affecting them",
            "AI models must be open source",
            "Only EU citizens can develop the AI"
        ],
        correct: 1,
        explanation: "GDPR Article 22 gives individuals the right to not be subject to solely automated decisions and to receive meaningful explanations about how automated decisions are made. Data residency is separate from this right. Open source and developer nationality aren't GDPR requirements."
    },
    {
        id: 87, domain: "D5",
        q: "A security team wants to scan S3 buckets containing AI training data for accidentally included PII before the data is used. Which AWS service should they use?",
        options: [
            "AWS WAF",
            "Amazon Macie",
            "AWS Shield",
            "Amazon Inspector"
        ],
        correct: 1,
        explanation: "Amazon Macie uses ML to automatically discover and classify sensitive data (PII) in S3 buckets. WAF protects web applications. Shield provides DDoS protection. Inspector scans for software vulnerabilities in EC2/containers."
    },
    {
        id: 88, domain: "D5",
        q: "An adversary is submitting carefully crafted data to corrupt a company's AI training dataset, hoping to manipulate the model's future behavior. What type of attack is this?",
        options: [
            "Prompt injection",
            "Data poisoning",
            "Model extraction",
            "Credential theft"
        ],
        correct: 1,
        explanation: "Data poisoning deliberately corrupts training data to manipulate model behavior. Prompt injection manipulates model outputs via malicious inputs at inference time. Model extraction attempts to steal the model. Credential theft targets authentication systems."
    },
    {
        id: 89, domain: "D5",
        q: "A company wants to demonstrate to auditors that their AI workloads on AWS meet SOC 2 compliance requirements. Which service provides compliance reports?",
        options: [
            "AWS Trusted Advisor",
            "AWS Artifact",
            "Amazon Detective",
            "AWS Compute Optimizer"
        ],
        correct: 1,
        explanation: "AWS Artifact provides access to AWS compliance reports and agreements (SOC, ISO, PCI DSS, etc.) for demonstrating compliance posture to auditors. Trusted Advisor gives optimization recommendations. Detective investigates security findings. Compute Optimizer recommends instance types."
    },
    {
        id: 90, domain: "D5",
        q: "An AI team is designing their cost management strategy for Amazon Bedrock usage. Which AWS tool helps them track and forecast AI service spending?",
        options: [
            "SageMaker Canvas",
            "AWS Cost Explorer and AWS Budgets",
            "Amazon Rekognition",
            "Amazon Forecast (the ML service)"
        ],
        correct: 1,
        explanation: "AWS Cost Explorer provides spending analysis and trends, while AWS Budgets enables setting cost alerts and thresholds for AI service usage. SageMaker Canvas is for no-code ML. Rekognition is for image analysis. Amazon Forecast predicts business metrics, not AWS costs."
    }
];

export default PRACTICE_QUESTIONS;
